import { translationStrings } from './translations';

export const translations = {
  ...translationStrings,
};
